import React from 'react';
import { Box } from '@/shared/ui/box';
import {  HeadingBoldH6 } from '@/shared/ui/typography2';

export const TitlePrepared = ({  tBonus }) => (
  <Box $padding={['8px 10px', 0]} $marginBottom={['18px', '12px']}>
  <HeadingBoldH6>{tBonus('select_bonus')}</HeadingBoldH6>
  </Box>
);

